import { IPAGE } from '@/types/base.d';
import fetch from './index';

// 获取敏感词列表
const getSensitive = (params: object) => fetch.axios_admin.get('/sensitivity/page?', { params });

// 敏感词添加
const addSensitive = (params: object) => fetch.axios_admin.post('/sensitivity', params);

// 敏感词删除
const delSensitive = (id: string) => fetch.axios_admin.remove(`/sensitivity/id/${id}`);

// 上传txt
const addTxt = (params: FormData) => fetch.axios_admin.post('/sensitivity/textSave', params, { headers: { 'Content-Type': 'multipart/form-data' } });

export default {
  getSensitive,
  addSensitive,
  delSensitive,
  addTxt,
};
